import { ListItem } from '@mui/material';
import { FC } from 'react';

import { IFeedbackModal } from 'components/layout/FeedbackModal';
import { ActionButton } from 'components/system/buttons';
import TrashIcon from 'components/system/Icons/TrashIcon';
import { TRemoveNotificationMutationFn } from 'generated/graphql';
import { useFeedbackModal } from 'providers';
import { logError } from 'utils/logError';
import NotificationCardContent from './NotificationCardContent';
import { INotificationCard } from './notifications.types';

const deleteNotification = (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  notificationId: string,
  openFeedbackModal: (props: IFeedbackModal) => void,
  removeNotification: TRemoveNotificationMutationFn,
) => {
  e.stopPropagation();
  openFeedbackModal({
    type: 'warning',
    title: 'Delete Notification',
    message: 'Are you sure you want to delete this notification?',
    cancelBtn: { label: 'Cancel' },
    submitBtn: {
      onClick: () => {
        removeNotification({
          variables: { notificationId },
        }).catch((error: unknown) => {
          logError({ error });
        });
      },
    },
  });
};

const NotificationCard: FC<INotificationCard> = ({
  data,
  updateNotification,
  removeNotification,
}) => {
  const { openFeedbackModal } = useFeedbackModal();

  return (
    <ListItem
      secondaryAction={
        <ActionButton
          aria-label="Delete notification"
          onClick={(e) =>
            deleteNotification(
              e,
              data._id,
              openFeedbackModal,
              removeNotification,
            )
          }
        >
          <TrashIcon />
        </ActionButton>
      }
    >
      <NotificationCardContent
        data={data}
        handleUpdate={() => {
          if (data._id) {
            void updateNotification({
              variables: { updateNotificationId: data._id },
            }).catch((error: unknown) => {
              logError({ error });
            });
          }
        }}
        removeNotification={() =>
          removeNotification({
            variables: { notificationId: data._id },
          })
        }
      />
    </ListItem>
  );
};

export default NotificationCard;
